import endpoints from '../endpoints.ts';
import api from '../api/index.ts';
import { MedAPI } from '../api/med.js';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { WithPagination } from '../types/types.ts';
import {
  HydratedQuarantineFoundMeds,
  HydratedQuarantine,
} from '../types/compoundModels.ts';

export const QUARANTINE_QUERY_KEY = 'QUARANTINE_QUERY_KEY';

const useReadManyQuarantineBySearch = (
  params: Partial<MedAPI.Request.ReadManyBySearch>,
  options?: Partial<UseQueryOptions<WithPagination<HydratedQuarantine> | null>>
) =>
  useQuery({
    queryKey: [
      QUARANTINE_QUERY_KEY,
      endpoints.quarantine.read.many.by.search(),
      params,
    ],
    queryFn: () => api.quarantine.read.many.by.search(params),
    ...options,
  });

const useReadCount = (options?: Partial<UseQueryOptions>) =>
  useQuery({
    queryKey: [QUARANTINE_QUERY_KEY, endpoints.quarantine.read.count()],
    queryFn: () => api.quarantine.read.count(),
    ...options,
  });

const useReadManyByCustomerLocationId = (
  params: { customerLocationIds: number[] },
  options?: Partial<UseQueryOptions<HydratedQuarantineFoundMeds[] | null>>
) =>
  useQuery({
    queryKey: [
      QUARANTINE_QUERY_KEY,
      endpoints.quarantine.read.many.by.customerLocationId(),
    ],
    queryFn: () => api.quarantine.read.many.by.customerLocationId(params),
    ...options,
  });

const quarantineQueryHooks = {
  useReadManyQuarantineBySearch,
  useReadCount,
  useReadManyByCustomerLocationId,
};

export default quarantineQueryHooks;
